import { ToutvUser } from "../ToutvUser";

/**
 * Add the "Declared Postal Code" behavior to the given array if a declared postal code is available.
 * @param behaviors The array to which the behavior should be added.
 */
export function addPostalCodeDeclaredBehavior(behaviors: string[]): void {
  const postalCode = dataLayerHelper.get<ToutvUser>("user")?.postalCode;
  if (postalCode) {
    behaviors.push(`Declared Postal Code : ${postalCode}`);
  }
}
